import {
  AfterViewInit, ChangeDetectorRef,
  Component,
  ElementRef, EventEmitter,
  Input,
  OnChanges, OnDestroy, OnInit, Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {DxDataGridComponent} from 'devextreme-angular';
import ArrayStore from 'devextreme/data/array_store';
import DataSource from 'devextreme/data/data_source';
import {of, Subject} from 'rxjs';
import {debounceTime, take, takeUntil} from 'rxjs/operators';
import {ScreenService} from '../../../../shared/services/general';
import {BillTo} from '../../models/billing/bill-type';
import {BillingInformation} from '../../models/billing/billing-information';
import {PatientEditable} from '../../models/order-entry/patient';
import {PatientService} from '../../services';

@Component({
  selector: 'app-bill-to',
  templateUrl: './bill-to.component.html',
  styleUrls: ['./bill-to.component.scss'],
})
export class BillToComponent implements AfterViewInit, OnChanges, OnInit, OnDestroy {
  @ViewChild('grid', {static: true}) public grid?: DxDataGridComponent;
  @ViewChild('container', {static: true}) public containerDiv?: ElementRef;
  @ViewChild('controls', {static: true}) public controlsDiv?: ElementRef;

  @Input() public disabled = false;
  @Input() public patient ?: PatientEditable;
  @Input() public selectedBillingInfo: any[] = [];
  @Input() public isEdit = false;
  @Input() public defaultBillTo = 'INSURANCE';

  @Output() public billToChanged = new EventEmitter();
  @Output() public billingInfoChanged = new EventEmitter();

  public selectedBillTo?: string;
  public selectedRowKeys: number[] | BillingInformation[] = [];
  public dataSource: DataSource;
  public buttons: any;
  public isPhone: boolean = false;
  public gridHeight: number = 100;
  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(private patientService: PatientService, private screen: ScreenService, public changeDetectorRef: ChangeDetectorRef) {
    this.dataSource = new DataSource({
      store: new ArrayStore({
        key: 'id',
        data: [],
      }),
    });

    this.buttons = [
      {
        name: 'Up',
        icon: 'chevronup',
        disabled: true
      },
      {
        name: 'Down',
        icon: 'chevrondown',
        disabled: true
      },
      {
        name: 'Refresh',
        icon: 'refresh',
        disabled: true
      },
      {
        name: 'Undo',
        icon: 'undo',
        disabled: true,
      },
      {
        name: 'Remove',
        icon: 'trash',
        disabled: true
      }
    ];
  }

  public ngAfterViewInit(): void {
    this.gridHeight = 240 - this.controlsDiv?.nativeElement.clientHeight;
    this.changeDetectorRef.detectChanges();
  }

  public convertRequisitionBillingInfoPositionToPatientBillingInfoOrder(pbi: BillingInformation[]) {
    // THIS NEEDS TO BE DONE BECAUSE REQUISITION BILLING INFORMATION POSITION STARTS IN ZERO AND PATIENT BILLING INFO ORDER STARTS IN ONE
    for (let i = 0; i < pbi.length; i++) {
      pbi[i].order = i + 1;
    }
    return pbi;
  }

  public ngOnInit(): void {
    this.defaultBillTo = this.ClientDefaultBillTo;
    this.billTypeChanged(this.ClientDefaultBillTo);

    this.isPhone = this.screen.sizes['screen-x-small'];
    this.screen.changed
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(() => {
        this.isPhone = this.screen.sizes['screen-x-small'];
      });
  }

  public onItemClick(e: any) {
    switch (e.itemData.name) {
      case 'Up':
        this.changeUp();
        break;
      case 'Down':
        this.changeDown();
        break;
      case 'Refresh':
        this.refresh(false);
        break;
      case 'Undo':
        this.refresh(true);
        break;
      case 'Remove':
        this.remove();
        break;
    }
  }

  public billTypeChanged(billTo: string) {
    this.selectedBillTo = billTo;
    this.changeStateButtons();
    this.billToChanged.emit(this.selectedBillTo);
  }

  public get ClientDefaultBillTo() {
    if (this.patient !== undefined && this.patient !== null && this.patient.client !== undefined
      && this.patient.client !== null && this.patient.client.defaultBillTo) {
      return BillTo[this.patient.client.defaultBillTo].toUpperCase();
    } else {
      return 'INSURANCE';
    }
  }

  public selectionChange() {
    of(null)
      .pipe(debounceTime(1000))
      .subscribe(() => this.changeStateButtons());
  }

  public changeStateButtons() {
    this.buttons = [
      {
        name: 'Up',
        icon: 'chevronup',
        disabled: this.DisableUpBtn
      },
      {
        name: 'Down',
        icon: 'chevrondown',
        disabled: this.DisableDownBtn
      },
      {
        name: 'Refresh',
        icon: 'refresh',
        disabled: this.patient === undefined || this.patient === null || this.selectedBillTo !== 'INSURANCE' || this.disabled
      },
      {
        name: 'Remove',
        icon: 'trash',
        disabled: this.disabled || this.selectedBillTo !== 'INSURANCE' || this.selectedRowKeys.length === 0
      }
    ];
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.defaultBillTo) {
      if (changes.defaultBillTo.currentValue) {
        this.billTypeChanged(changes.defaultBillTo.currentValue);
      }
    }
    if (changes.patient && changes.patient.currentValue) {
      this.changeStateButtons();
      if (changes.patient.currentValue.id !== undefined
        && changes.patient.currentValue.id !== null) {

        this.patientService.getPatientBillingInformation(changes.patient.currentValue.id)
          .pipe(take(1))
          .subscribe(pbi => {
            if (this.isEdit) {
              pbi = pbi
                .filter(i => this.selectedBillingInfo?.map((s: any) => s.patientBillingInformationId).includes(i.id))
                .map(i => {
                  const selectedIndex = this.selectedBillingInfo?.findIndex((s: any) => s.patientBillingInformationId === i.id) as number;
                  // @ts-ignore
                  i.order = this.selectedBillingInfo[selectedIndex].position;
                  return i;
                });
              // @ts-ignore
              pbi.sort((a, b) => a.order - b.order);
              pbi = this.convertRequisitionBillingInfoPositionToPatientBillingInfoOrder(pbi);
            } else {
              // @ts-ignore
              pbi.sort((a, b) => a.order - b.order);
            }
            this.dataSource = new DataSource({store: new ArrayStore({key: 'id', data: pbi})});
            this.grid?.instance.refresh();
            this.billingInfoChanged.emit((this.dataSource.store() as ArrayStore).createQuery().toArray());
          });
      }
    }
  }

  public refresh(undo: boolean = false) {
    if (this.patient)
    this.patientService.getPatientBillingInformation(this.patient?.id)
      .pipe(take(1))
      .subscribe(pbi => {
        pbi = pbi
          .filter(i => !undo || this.selectedBillingInfo.map(s => s.patientBillingInformationId).includes(i.id))
          .map((i, index) => {
            if (undo) {
              const selectedIndex = this.selectedBillingInfo.findIndex(s => s.patientBillingInformationId === i.id);
              i.order = this.selectedBillingInfo[selectedIndex].position;
            } else {
              i.order = index;
            }
            return i;
          });
        // @ts-ignore
        pbi.sort((a, b) => a.order - b.order);
        pbi = this.convertRequisitionBillingInfoPositionToPatientBillingInfoOrder(pbi);
        this.dataSource = new DataSource({
          store: new ArrayStore({
            key: 'id',
            data: pbi,
          }),
        });
        this.grid?.instance.refresh();
        this.billingInfoChanged.emit((this.dataSource.store() as ArrayStore).createQuery().toArray());
      });
  }

  public remove() {
    this.selectedRowKeys.forEach(x => {
      const selectedId = typeof x === 'number' ? x : (x as BillingInformation).id;
      this.dataSource.store().remove(selectedId);
    });
    this.selectedRowKeys = [];
    this.convertRequisitionBillingInfoPositionToPatientBillingInfoOrder((this.dataSource.store() as ArrayStore).createQuery().toArray());
    this.grid?.instance.refresh();
    this.billingInfoChanged.emit((this.dataSource.store() as ArrayStore).createQuery().toArray());
  }

  public get DisableUpBtn() {
    if (this.DisableChangePositionsBtn) {
      return true;
    }

    const selectedId = typeof this.selectedRowKeys[0] === 'number' ?
      this.selectedRowKeys[0] :
      (this.selectedRowKeys[0] as BillingInformation).id;
    const filtered = (this.dataSource.store() as ArrayStore).createQuery().filter(['id', '=', selectedId]).toArray();
    if (filtered.length === 0) {
      return true;
    }
    return filtered[0].order === 1;
  }

  public get DisableDownBtn() {
    if (this.DisableChangePositionsBtn) {
      return true;
    }

    const selectedId = typeof this.selectedRowKeys[0] === 'number' ?
      this.selectedRowKeys[0] :
      (this.selectedRowKeys[0] as BillingInformation).id;
    const filtered = (this.dataSource.store() as ArrayStore).createQuery().filter(['id', '=', selectedId]).toArray();
    if (filtered.length === 0) {
      return true;
    }
    return filtered[0].order === (this.dataSource.store() as ArrayStore).createQuery().toArray().length;
  }

  private get DisableChangePositionsBtn() {
    return this.disabled || this.selectedBillTo !== 'INSURANCE' || this.selectedRowKeys.length !== 1 ||
      this.dataSource === undefined || (this.dataSource.store() as ArrayStore).createQuery().toArray().length <= 1;
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  private getIndexesOfSelected() {
    const indexes: number[] = [];

    this.grid?.instance.getSelectedRowsData()
      .forEach((rp: BillingInformation) => {
        const index = (this.dataSource.store() as ArrayStore).createQuery().toArray()
          .findIndex((r: any) =>
            r.billTypeId === rp.billTypeId &&
            r.payerId === rp.payerId &&
            r.insuranceId === rp.insuranceId,
          );

        indexes.push(index);
      });

    return indexes;
  }

  public changeDown() {
    const prev = Math.max(...this.getIndexesOfSelected()) + 1;
    const array = (this.dataSource.store() as ArrayStore).createQuery().toArray();

    if (prev < array.length) {
      array[prev].order = array[Math.min(...this.getIndexesOfSelected())].order;
      this.getIndexesOfSelected().forEach(index => array[index].order++);
      array.sort((a: any, b: any) => a.order - b.order);
      this.dataSource = new DataSource({store: new ArrayStore({data: array}), key: 'id'});
      this.billingInfoChanged.emit(array);
      this.grid?.instance.refresh();
    }
  }

  public changeUp() {
    const prev = Math.min(...this.getIndexesOfSelected()) - 1;
    const array = (this.dataSource.store() as ArrayStore).createQuery().toArray();

    if (prev >= 0) {
      array[prev].order = array[Math.max(...this.getIndexesOfSelected())].order;
      this.getIndexesOfSelected().forEach(index => array[index].order--);
      array.sort((a: any, b: any) => a.order - b.order);
      this.dataSource = new DataSource({store: new ArrayStore({data: array}), key: 'id'});
      this.billingInfoChanged.emit(array);
      this.grid?.instance.refresh();
    }
  }

}
